import _ from 'lodash';
import ObservablePropertyDescriptorObject from '../../utils/ObservablePropertyDescriptorObject';
import PropertyDescriptor from '../../utils/PropertyDescriptor';
import ModelActionProperty from "./ModelActionProperty";

export default class Model extends ObservablePropertyDescriptorObject {

    name = new PropertyDescriptor("", '事件名称', "基本", "enum", "#anticon-speed", {
        description: "需要订阅的事件的名称",
        showValue: true,
        valuesGetter: () => {
            return [new PropertyDescriptor("", "无", "", "string", "#anticon-no-data"), ...(this._sys.__model._.events.values || [])];
        }
    });

    actions = new PropertyDescriptor([], '动作', "高级", "objects", "#anticon-GroupCopy", {
        description: "事件触发时，执行的动作。当有多个动作时，将从上到下依次执行",
        // visible: false,
        modelTemplate: ModelActionProperty,
        modelGetter: (opts) => {
            const m = new ModelActionProperty(opts);
            // m._sys.__runScript = this._sys.ui && this._sys.ui.runScript.bind(this._sys.ui);
            return m;
        },
    });

    constructor(opts = {}) {
        super();

        for (var p in opts) {
            this[p].value = opts[p];
        }

        this.defineAllProperties();
    }

    onPropertyValueChanged(name, valOld, valNew, subName, args) {
        // if (name === "name") {
        //     this.setPropertyVisible("actions", valNew !== "none");
        // }
    }

    run(data, opts) {
        this.actions.forEach(c => {
            c.run(data, opts);
        });
    }

    toString() {
        const item = (this._sys.__model && this._sys.__model._.events.values || []).find(c => c.value === this.name);

        return this.name && {
            svg: `#anticon-speed`,
            text: `${item && item.alias || this.name}`
        } || "<请选择需要订阅的事件>";
    }
}
